

export default {
    // 实时变化Signature
    makeSignature(params, reqTime) {
        let paramsKeys = Object.keys(params).sort();
        let paramsStr = '';
        for (let paramsKey of paramsKeys) {
            paramsStr += `${paramsKey}=${params[paramsKey]}&`;
        }
        return $.md5(paramsStr + reqTime);
    },

    // 获取网站来源
    getUrlParam(name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
        let r = window.location.search.substr(1).match(reg);
        if (r != null) return unescape(r[2]);
        return null;
    },

    // gTag
    gtag() {
        dataLayer.push(arguments);
    },

    // style函数
    handleScale() {
        let winWidth = $(window).width();
        let winHeight = $(window).height();
        const contScale = Math.min(((winWidth / winHeight) / (1920 / 1080)), ((winHeight / winWidth) / (1080 / 1920)));
        return {
            transform: "matrix(" + contScale + ", 0, 0, " + contScale + ", 0, 0)",
        };
    },
    // 宽高比
    handleVideoSize() {
        console.log('1111  handleVideoSize  11111')
        const scalex = $(window).width() / 1920;
        const scaley = $(window).height() / 1080;
        const vscale = Math.max(scalex, scaley);
        const vwidth = 1920 * vscale;
        const vheight = 1080 * vscale;

        // $set('width', vwidth + 'px', 'height', vheight + 'px', marginLeft + (-vwidth / 2) + 'px')
        console.log('1111', vheight)
        return {
            width: vwidth + 'px',
            height: vheight + 'px',
            marginLeft: (-vwidth / 2) + 'px',
        };
    },
    // 统一链接
    goStore(code) {
        switch (code) {
            case 'AS':
                alert('마켓 사전예약은<br/>준비중에 있습니다');
                // gtag('event', '跳转苹果预约');
                // window.open(`https://apps.apple.com/app/${APP_IOS_PKG}`, '_blank');
                break;
            case 'GP':
                alert('마켓 사전예약은<br/>준비중에 있습니다');
                // gtag('event', '跳转谷歌预约');
                // window.open(`https://play.google.com/store/apps/details?id=${APP_ANDROID_PKG}`, '_blank');
                break;
        }
    },

    goShare(code) {
        switch (code) {
            case 'fb':
                gtag('event', '跳转Facebook');
                window.open(`https://www.facebook.com/%EC%86%94%EB%9D%BC-%EB%A6%AC%EB%B0%94%EC%9D%B4%EB%B2%8CSolar-Revival-111141161350819`, '_blank');
                break;
            case 'yt':
                gtag('event', '跳转Youtube');
                window.open(`https://www.youtube.com/channel/UC83l2hRWb-LPcnVCHalZHxQ`, '_blank');

                break;
            case 'cafe':
                gtag('event', '跳转Cafe');
                window.open(`https://cafe.naver.com/solarrevival`, '_blank');
                break;
            case 'gp':
                gtag('event', '谷歌预约');
                window.open(`https://play.google.com/store/apps/details?id=com.ujoygp.panilla`, '_blank');
                break;
            case 'as':
                gtag('event', '苹果预约');
                window.open(`https://apps.apple.com/app/id1570211191`, '_blank');
                break;
            case 'os':
                gtag('event', 'onestore预约');
                // window.open(`https://m.onestore.co.kr/mobilepoc/url/urlMapping.omp?param=0000756168`, '_blank');
                window.open(`https://onesto.re/_1rUai34`, '_blank');
                break;
            case 'bbs':
                gtag('event', '跳转Cafe');
                window.open(`https://cafe.naver.com/solarrevival/menu/26`, '_blank');
                break;
        }
    },

    doShare(code) {
        switch (code) {
            case 'fb':
                fbq('track', 'AddToWishlist');
                gtag('event', '完成Facebook分享');
                window.open('https://www.facebook.com/sharer.php?display=popup&u=' + CDN_URL + '/share/index.html', 'sharer', 'toolbar=0,status=0,resizable=1,width=626,height=436');
                break;

            case 'twi':
                fbq('track', 'AddToWishlist');
                gtag('event', '完成Twitter分享');
                window.open(encodeURI('https://twitter.com/intent/tweet?url=' + SHARE_URL + '&text=' + SHARE_CONTEXT + '&hashtags=' + SHARE_TAGS));
                break;

            case 'line':
                fbq('track', 'AddToWishlist');
                gtag('event', '完成LINE分享');
                window.open(encodeURI('https://lineit.line.me/share/ui?url=' + SHARE_URL + '&text=' + SHARE_CONTEXT + '&hashtags=' + SHARE_TAGS));
                break;

            case 'kk':
                fbq('track', 'AddToWishlist');
                gtag('event', '完成Kakao分享');
                break;
        }
    }

}


// WEBPACK FOOTER //
// ./src/commonFunction/common.js